import type { HTMLChakraProps } from "@chakra-ui/react";
import { chakra, forwardRef, useStyles } from "@chakra-ui/react";
import { __DEV__, cx } from "../../../utils/chakra";

export type SurfaceSectionProps = HTMLChakraProps<"div">;

export const SurfaceSection = forwardRef<SurfaceSectionProps, "div">(({ ...props }, ref) => {
    const styles = useStyles();

    return (
        <chakra.div
            ref={ref}
            {...props}
            className={cx("chakra-surface__section", props.className)}
            __css={styles.section}
        />
    );
});

if (__DEV__) {
    SurfaceSection.displayName = "PanelSection";
}
